<!-- HTML -->
<template>
  <div>
    <section class="section hero hero-bg-image is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-mobile">
            <div class="column is-10 is-offset-2">
              <transition
                appear
                name="drop-6"
                mode="out-in"
              >
                <h3 class="subtitle is-3">NEW INDUSTRIAL ALBUM</h3>
              </transition>
              <transition
                appear
                name="drop-7"
                mode="out-in"
              >
                <HomeGlitchText />
              </transition>
              <transition
                appear
                name="drop-8"
                mode="out-in"
              >
                <h5 class="subtitle is-5">
                  AVAILABLE EVERYWHERE
                </h5>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-foot">
        <transition
          appear
          name="drop-9"
          mode="out-in"
        >
          <div class="vertical-container">
            <div class="vertical-wrapper">
              <h3>
                <i class="fas fa-hashtag"></i>industrial /
                <i class="fas fa-hashtag"></i>electro /
                <i class="fas fa-hashtag"></i>the-factory-bloc
              </h3>
            </div>
          </div>
        </transition>
        <transition
          appear
          name="drop-10"
          mode="out-in"
        >
          <figure class="image is-48x48 is-pulled-right mouse">
            <img src="../../assets/icons/other/mouse.svg" alt="Mouse animation">
            <img src="../../assets/icons/other/mouse-wheel.svg" alt="Mouse wheel animation">
          </figure>
        </transition>
      </div>
    </section>
  </div>
</template>

<!-- JavaScript -->
<script>

import HomeGlitchText from "@/components/home/HomeGlitchText.vue";

export default {

  name: "HomeHeader",

  components: {

    HomeGlitchText

  }

}
</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";
@import "../../assets/scss/transitions.scss";

// Text
h3 {
  color: $green;
}
h5 {
  color: $gray-tint-2;
}
h5::before {
  content: "//////";
  color: $green;
}

// Vertical Text
.vertical-container {
  min-width: 1px;
  position: relative;
  h3 {
    font-size: .8rem;
    color: $gray-tint-2;
    text-transform: uppercase;

  }
  .fa-hashtag {
    color: $green-tint-2;
  }
}
.vertical-wrapper {
  position: absolute;
  bottom: -80px;
  left: 4px;
  margin-left: 0;
  width: 500px;
  transform: rotate(270deg);
  transform-origin: 0 0;
}

// Mouse
.mouse {
  position: relative;
  width: 48px;
  height: 48px;
}
.mouse > img:first-child {
	position: absolute;
  bottom: -16px;
  right: -4px;
}
.mouse > img:last-child {
	position: absolute;
  bottom: -16px;
  right: -4px;
}
.mouse > img:last-child {
  animation: mousewheel 2.2s infinite linear;
}
@keyframes mousewheel {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-12px);
  }
	100% {
    transform: translateY(0px);
  }
}
@media screen and (max-width: 512px) {
  .column {
    margin-left: 10% !important;
  }
  h3 {
    font-size: 1.25rem !important;
  }
  .vertical-wrapper h3 {
    font-size: 1rem !important;
  }
}
</style>
